module.exports = __webpack_public_path__ + "img/PC2.5a7d95c9.png";